"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Skeleton = require("@insided/shared/uikit/Skeleton");

var CategoryListCard = function CategoryListCard(_ref) {
  var key = _ref.key,
      title = _ref.title,
      showAllLink = _ref.showAllLink,
      url = _ref.url,
      children = _ref.children;
  return (0, _preact.h)("section", {
    className: "category-list__container",
    key: key
  }, (0, _preact.h)("a", {
    className: "category-list__container--header-link category-list__container--header",
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, (0, _preact.h)("h4", {
    className: "category-list__container--header-title"
  }, title)), (0, _preact.h)("div", {
    className: "category-list__container--body"
  }, children), showAllLink && (0, _preact.h)("a", {
    className: (0, _classnames.default)('category-list__container--view-all-link', 'link', 'category-list__container--view-all'),
    href: (0, _absoluteUrlRuntime.resolveUrl)(url)
  }, (0, _preact.h)(_phrase.default, {
    p: "curated.content.view.all"
  }, function (phrase) {
    return phrase || (0, _preact.h)(_Skeleton.TextSkeleton, {
      width: "5em",
      style: {
        lineHeight: '24px'
      }
    });
  })));
};

var _default = CategoryListCard;
exports.default = _default;